import { FC } from 'react';
import { type UseFormReturn, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PHRASE_TYPES } from '@/entities/conversations';
import { TranscriptRecordForm } from './TranscriptRecordForm';
import { TranscriptRecordFormFrame } from './TranscriptRecordFormFrame';
import type { TranscriptRecordFormValues } from './types';

type Props = {
  form: UseFormReturn<TranscriptRecordFormValues>;
  /** Отрезок этой реплики выделяется на шкале записи */
  isTimelineTarget: boolean;
  onSubmit: () => void;
  /** Пользователь перешёл к полям этой реплики */
  onFocus: () => void;
};

/**
 * Новая реплика из вынесенного фрагмента — под исходной, в той же правке: сохраняются и отменяются вместе.
 */
export const TranscriptSplitPhraseForm: FC<Props> = ({ form, isTimelineTarget, onSubmit, onFocus }) => {
  const { t } = useTranslation(['dialogs']);
  const personId = useWatch({ control: form.control, name: 'personId' });

  return (
    <div onFocusCapture={onFocus}>
      <TranscriptRecordFormFrame type={PHRASE_TYPES.PHRASE} personId={personId}>
        <TranscriptRecordForm
          form={form}
          type={PHRASE_TYPES.PHRASE}
          title={t('dialogs:transcriptEdit.splitTitle')}
          isTimelineTarget={isTimelineTarget}
          onSubmit={onSubmit}
        />
      </TranscriptRecordFormFrame>
    </div>
  );
};
